import React from "react";
import { connect } from "react-redux";
import { setInitialLoading } from "../../Redux/slices/loader";

const mapStateToProps = state => {
    return {
        initialLoading: state.loader.initial.loading,
        activeRequests: state.loader.initial.activeRequests,
        inlineLoading: state.loader.inline.loading
    }
}

const mapDispatchToProps = dispatch => {
    return {
        setInitialLoading: payload => dispatch(setInitialLoading(payload))
    }
}

class LoadingContainer extends React.Component {
    constructor() {
        super();
        this.state = {
            inlineLoading: false
        }
    }

    componentDidUpdate() {
        if (this.props.activeRequests === 0 && this.props.initialLoading === true) {
            this.props.setInitialLoading(false);
        }

        if (this.props.inlineLoading === true && this.state.inlineLoading === false) {
            this.setState({
                inlineLoading: true
            });
        } else if (this.props.inlineLoading === false && this.state.inlineLoading === true) {
            var state = this;
            setTimeout(function() {
                state.setState({
                    inlineLoading: false
                });
            }, 200);
        }
    }

    render() {
        return <div>
            {/* <div className={"loading-container" + (!false ? " hidden" : "")}>
                <img src="/wp-content/themes/veronica-virta/assets/" />
            </div> */}

            <div className={"inline-loading-container" + (!this.props.inlineLoading ? " hidden" : "")}>
                <div className="progress-bar" style={{
                    width: this.state.inlineLoading ? "100%" : "0%"
                }}></div>
            </div>

            {this.props.children}
        </div>
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadingContainer);